const APPLICATION_LIST_EN = Object.freeze({
  'application-list.title': 'Application List',
  'application-list.empty.list': 'No data available',
  'application-list.new.application': 'New Application',
  'application-list.application.no': 'Application No.',
  'application-list.application.status': 'Application Status',
  'application-list.application.create-date': 'Created Date',
  'application-list.application.update-date': 'Last Modified Date',
  'application-list.application.remarks': 'Remarks',
  'application-list.application.applicationType': 'Application Type',
  'application-list.application.reason': 'Rejection Reason',
  'application-list.application.company.name': 'Company Name',
  'application-list.application.store.isValidated': 'Store Validated',
  'application-list.application.applicant.status': 'Applicant Status',
  'application-list.application.mainlandcompanyname': 'Mainland Company Name',
  'application-list.application.hongkongcompanyname': 'Hong Kong Company Name',
  'application-list.admin.mode': 'Admin Mode',
  'application-list.admin.partner.referral': 'Generate Partner Link',
  'application-list.admin.sales.referral': 'Copy Referral URL',
});

const APPLICATION_EN = Object.freeze({
  'application.status.draft': 'Draft',
  'application.status.under-review': 'Under Review',
  'application.status.approved': 'Approved, Pending Signing',
  'application.status.rejected': 'Pending Review',
  'application.status.to-be-signed': 'Pending Signing',
  'application.status.to-be-verified': 'Signed, Under Verification',
  'application.status.accepted': 'Eligible for Loan Application',
  'application.applicant.status.applicant': 'Applicant',
  'application.applicant.status.prospective.seller': 'Prospective Seller',
  'application.applicant.status.rejected.applicant': 'Rejected Applicant',
  'application.applicant.status.seller': 'Seller',
});

export { APPLICATION_LIST_EN, APPLICATION_EN };
